module.exports = __webpack_public_path__ + "img/cover-redeem-bg.7f7cfa46.jpg";